/**
 * Input — Linear-style sky focus ring (brand spec §3 + tokens.css `.input`).
 */
import * as React from "react";
import { cn } from "../lib/cn.js";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        // Placeholder is a hint, not content: one step down in size and
        // lighter than --muted (see `--placeholder` in tokens.css).
        "w-full h-10 px-3 bg-paper border border-line rounded-sm text-ink",
        "placeholder:text-sm placeholder:text-placeholder",
        "transition-colors hover:border-line-2",
        "focus-visible:outline-hidden focus-visible:border-accent focus-visible:ring-2 focus-visible:ring-accent-subtle",
        className,
      )}
      {...props}
    />
  );
});
